module.exports = __webpack_public_path__ + "static/img/myOrder.aec3b993.png";